import { useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import throttle from 'lodash/throttle';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import {
  selectIsLoanChangesLoaded,
  selectPendingChangesAuthorsFullNames,
} from 'store/loanApplications/selectors';

import { THROTTLE_TIMEOUT } from './constants';

const usePendingChangesDependentFetch = fetchData => {
  const [triggerFetch, setTriggerFetch] = useState(true);

  const pendingChangesAuthorsFullNames = useSelector(selectPendingChangesAuthorsFullNames);
  const isChangesLoaded = useSelector(selectIsLoanChangesLoaded);

  const prevIsChangesLoadedRef = useRef();

  useEffectSafeStrictMode(() => {
    if (prevIsChangesLoadedRef.current) {
      setTriggerFetch(prev => !prev);
    }

    prevIsChangesLoadedRef.current = isChangesLoaded;
  }, [pendingChangesAuthorsFullNames, isChangesLoaded]);

  const throttledFetch = useMemo(
    () => throttle(fetchData, THROTTLE_TIMEOUT, { leading: true, trailing: true }),
    [fetchData],
  );

  useEffectSafeStrictMode(() => {
    throttledFetch();

    return () => throttledFetch.cancel();
  }, [throttledFetch, triggerFetch]);
};

export default usePendingChangesDependentFetch;
